import { gql } from '@apollo/client';

export const GET_ALL_TESTS = gql`
  query GetAllTests {
    tests {
      TestId
      TestName
      TestCode
      Amount
      categories
      DepartmentId
      Special_Amount
      Units
      SampleTypeOrderNo
    }
  }
`;

export const SEARCH_TESTS = gql`
  query SearchTests($searchTerm: String!) {
    searchTests(searchTerm: $searchTerm) {
      TestId
      TestName
      TestCode
      Amount
      categories
    }
  }
`;

export const GET_TESTS_BY_CATEGORY = gql`
  query GetTestsByCategory($category: String!) {
    testsByCategory(category: $category) {
      TestId
      TestName
      TestCode
      Amount
    }
  }
`;